const services = [
  {
    category: "Web Application Development",
    items: [
      "Custom Web Application Development",
      "Single Page Applications (SPAs)",
      "Progressive Web Apps (PWAs)",
      "Responsive Web Design",
      "UI/UX Design and Implementation",
    ],
  },
  {
    category: "Backend Development",
    items: [
      "API Development and Integration",
      "Microservices Architecture",
      "Database Design and Management",
      "Backend Performance Optimization",
      "Authentication and Authorization Systems",
    ],
  },
  {
    category: "Full Stack Development",
    items: [
      "End-to-End Web Application Development",
      "Frontend and Backend Integration",
      "Real-time Data Processing",
      "Scalable Application Architecture",
      "Maintenance and Support",
    ],
  },
  {
    category: "Database Management",
    items: [
      "Database Schema Design",
      "Database Performance Tuning",
      "Data Security and Integrity",
    ],
  },
  {
    category: "DevOps and Infrastructure",
    items: ["Containerization and Orchestration", "Cloud Services Integration"],
  },
  {
    category: "Quality Assurance and Testing",
    items: ["Automated Testing", "Manual Testing", "Performance Testing"],
  },
  {
    category: "AI Integration",
    items: ["AI-driven Application Development"],
  },
];

export default services;
